<template>
  <ComingSoon />
</template>

<script>
import ComingSoon from "./ComingSoon"

export default {
  name: 'RewardsTopUsersTab',

  components: { ComingSoon },
}
</script>